<template>
  <div>
    <div class="login-bg">
      <div class="container">
        <div
          class="row w-100 align-items-center justify-content-center"
          style="height: 100vh"
        >
          <div class="col-2"></div>
          <div class="col-8" style="">
            <div class="login-box">
              <div class="row">
                <div class="col-sm" style="text-align: left">
                  <span class="logtin-title fontsiyuanbold">登录</span>
                </div>
              </div>
              <b-form @submit.stop.prevent style="margin-top: 30px">
                <b-form-input
                  class="login-input"
                  v-model="dataUserName"
                  :state="vUsername"
                  placeholder="用户名*"
                ></b-form-input>
                <b-form-invalid-feedback :state="vUsername">
                  请输入50位以内的用户名
                </b-form-invalid-feedback>

                <b-form-input
                  class="login-input"
                  v-model="dataPassword"
                  :state="vPassword"
                  placeholder="密码*"
                ></b-form-input>
                <b-form-invalid-feedback :state="vPassword">
                  请输入100位以内的密码
                </b-form-invalid-feedback>
              </b-form>

              <div class="login-info" style="text-align: left; font-size: 13px">
                <b-link class="login-info-important" href="#"
                  >了解如何获得登录授权密码?</b-link
                >
              </div>
              <div class="login-button">
                <b-button block variant="danger" @click="login">登陆</b-button>
              </div>
              <div class="login-info">
                需要创建一个账号吗？<b-link
                  href="#"
                  class="login-info-important"
                  >现在咨询</b-link
                >
              </div>
            </div>
            <div class="web-info">
              公网安备 浙公网安备 13037210号 © 2004 - 2021 TIANXIN 版权所有
              浙ICP备13037210号-1
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dataUserName: "GUEST",
      dataPassword: "",
      vUsername: null,
      vPassword: null,
    };
  },
  computed: {
    // vUsername() {
    //   return this.dataUserName.length > 4 && this.dataUserName.length < 13;
    // },
  },
  watch: {
    dataUserName(a) {
      this.vUsername = a.length > 0 && a.length < 50;
    },
    dataPassword(a) {
      this.vPassword = a.length > 0 && a.length < 100;
    },
  },
  methods: {
    login() {
      const _this = this;
      this.$store
        .dispatch("login", {
          pwd: _this.dataPassword,
        })
        .then((data) => {
          if (data.success) {
            console.log("loginsuccess");
            if (_this.$store.state.loginmode === "in") {
              _this.$router.push(_this.$store.state.loginpath);
            }
            if (_this.$store.state.loginmode === "out") {
              window.open(_this.$store.state.loginpath, "_blank");
            }
          } else {
            _this.$bvToast.toast(data.msg, {
              title: "警告",
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        });
    },
  },
};
</script>
<style>
.logtin-title {
  font-size: 30px;
  padding: 0 5px;
  border-bottom: 4px #d00031 solid;
}
.login-bg {
  text-align: center;
  height: 100vh;
  background-color: #ededed;
}
.login-box {
  padding: 40px;
  background-color: #fff;
}
.login-button {
  margin-top: 20px;
  width: 40%;
  margin-left: 30%;
  text-align: center;
}
.login-info {
  margin-top: 10px;
  font-size: 13px;
  color: #000;
}
.login-info-important {
  color: #d00031;
}
.web-info {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #808080;
}
.login-input {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  -webkit-touch-callout: auto;
  -webkit-user-select: auto;
  -khtml-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  user-select: auto;
  -webkit-user-drag: auto;
}

.login-input:focus {
  border: 1px #d00031 solid;
}
@media only screen and (max-width: 500px) {
  .login-button {
    margin-top: 20px;
    width: 70%;
    margin-left: 15%;
    text-align: center;
  }
}
</style>
